import React from 'react';
import { Pagination } from 'antd';

interface ListPaginationProps {
  current: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}

const PAGE_SIZE_OPTIONS = ['10', '20', '30', '40', '50'];

// Mirrors Authentication76's ListPagination (antd Pagination + a size
// changer), but driven by a server-computed total rather than slicing an
// already-fetched array client-side — the search endpoint paginates for real.
const ListPagination: React.FC<ListPaginationProps> = ({ current, total, pageSize, onChange, onPageSizeChange }) => {
  if (total <= pageSize) return null;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
      <Pagination
        current={current}
        total={total}
        pageSize={pageSize}
        showSizeChanger={!!onPageSizeChange}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        onChange={(page, size) => {
          if (size !== pageSize) onPageSizeChange?.(size);
          onChange(page);
        }}
      />
    </div>
  );
};

export default ListPagination;
